import styled from "@emotion/styled"
import { yupResolver } from "@hookform/resolvers/yup"
import { Button, Typography } from "@mui/material"
import { getLostFoundCaseStatus } from "api"
import { useTranslations } from "next-intl"
import Image from "next/image"
import { useRef } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import { useForm } from "react-hook-form"
import { extractProperty, replaceRichTextLinks } from "utils"
import { commonSchema, regex } from "utils/FormSchema"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"
import * as yup from "yup"
import InformationBlocks from "./components/InformationBox"
import {
  CustomTextField,
  Header,
  NumbersController,
  prefixOptionsArray,
} from "./Forms/Common"
const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledForm = styled.div`
  display: flex;
  padding: 24px 16px;
  gap: 16px;
  flex-direction: column;
  border-radius: 12px;
  box-shadow: 0px 2px 8px 0px rgba(38, 48, 61, 0.16);

  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 24px;
    gap: 32px;
  }
`

const Strip = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  background: rgba(27, 189, 119, 0.08);
  max-width: 700px;
`

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 32px;
    flex-direction: row;
  }
`

const StyledButton = styled(Button)`
  width: 100%;
  height: 56px;
`

export default function LossReports({
  data,
  locale,
}: {
  data: any
  locale: "he" | "en" | "ar" | "ru"
}) {
  const formTitle = extractProperty(data, "formTitle")
  const tipIcon = extractProperty(data, "tipIcon")
  const tipText = extractProperty(data, "tipText")
  const t = useTranslations("Forms")
  const tInner = useTranslations("InnerPages")
  const reCaptchaRef = useRef<ReCAPTCHA>(null)
  const schema = yup.object({
    caseNumber: yup
      .string()
      .matches(regex.onlyNumbers, "מספר פנייה אינו תקין")
      .required("מספר פנייה אינו תקין"),
    cellphone: commonSchema.common(locale).phonePrefix,
    phone: commonSchema.common(locale).phone,
  })
  type FormData = yup.InferType<typeof schema>
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitted, isValid },
  } = useForm<FormData>({
    resolver: yupResolver(schema),
    defaultValues: {
      cellphone: prefixOptionsArray[0].value,
    },
  })
  const onSubmit = async (data: FormData) => {
    try {
      const res = await getLostFoundCaseStatus(
        Number(data.caseNumber),
        Number(data.cellphone + data.phone),
      )
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <StyledLayout>
      <StyledForm>
        <Header title={formTitle} />
        <Strip>
          <Image
            src={getUmbracoMediaUrl(tipIcon)}
            alt=""
            width={32}
            height={32}
          />
          <Typography
            sx={{ "& p": { margin: 0 } }}
            variant="body2"
            dangerouslySetInnerHTML={{ __html: replaceRichTextLinks(tipText) }}
          />
        </Strip>
        <FormContainer onSubmit={handleSubmit(onSubmit)}>
          <CustomTextField
            name="caseNumber"
            control={control}
            label="מספר פנייה"
            required={true}
            isSubmitted={isSubmitted}
            errors={errors}
          />
          <NumbersController
            phoneName="phone"
            prefixName="cellphone"
            control={control}
            label={t("mobileNumber")}
            required={true}
            isSubmitted={isSubmitted}
            errors={errors}
            locale={locale}
          />
          <StyledButton variant="primary" type="submit">
            {tInner("submitInquiry")}
          </StyledButton>
        </FormContainer>
      </StyledForm>
      <InformationBlocks data={data} />
    </StyledLayout>
  )
}
